import type { FieldDef, FormSchemaProperty } from '../types';

// Converts a single JSON Schema property fragment into a builder FieldDef.
// Shared by toFieldDefs (whole schema) and the library pickers (one question).
const propertyToFieldDef = (
  key: string,
  property: FormSchemaProperty,
  required: boolean
): FieldDef => {
  const ui = property['x-ui'];

  const field: FieldDef = {
    key,
    label: property.title ?? key,
    widget: ui.widget,
    required
  };
  if (ui.multiple) field.multiple = true;
  if (ui.placeholder) field.placeholder = ui.placeholder;
  if (ui.description) field.description = ui.description;
  if (ui.widget === 'select' || ui.widget === 'radio') {
    field.options = ui.options ?? [];
    if (ui.allowOther) field.allowOther = true;
  }
  if (property.pattern) field.pattern = property.pattern;
  if (ui.patternMessage) field.patternMessage = ui.patternMessage;
  if (ui.widget === 'autocomplete') field.model = ui.model ?? 'staff';
  if (ui.widget === 'html_content') field.body = ui.body ?? '';
  if (ui.widget === 'image') field.url = ui.url ?? '';
  if (ui.questionId) field.questionId = ui.questionId;
  if (ui.inLibrary) field.inLibrary = true;
  if (ui.sectionKey) field.sectionKey = ui.sectionKey;

  return field;
};

export default propertyToFieldDef;
